import { createApp } from "vue";
import App from "./App.vue";
import { createRouter, createWebHistory } from "vue-router";
import { createI18n } from "vue-i18n";
import PrimeVue from "primevue/config";
import "primevue/resources/themes/lara-light-blue/theme.css";
import "primeicons/primeicons.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import "./assets/css/style.css";
import SwiperCore, { Autoplay, EffectCoverflow } from 'swiper'

// 导入路由配置
import routes from "./router";

// 导入国际化文件
import zh from "./i18n/zh.js";
import en from "./i18n/en.js";

// 配置路由
const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior() {
    return { top: 0 };
  },
});

// 配置i18n
const i18n = createI18n({
  legacy: false, // 使用Composition API模式
  locale: "zh", // 默认语言
  fallbackLocale: "zh", // 找不到时使用的语言
  messages: {
    zh,
    en,
  },
});

import { createPinia } from 'pinia'
const app = createApp(App);

app.use(router);
app.use(i18n);
app.use(PrimeVue);
app.use(createPinia());
SwiperCore.use([Autoplay, EffectCoverflow])

app.mount("#app");
